import {COOKIE_STORAGE_NAME} from "../../utils/constants";
import {isLocalStorageAvailable} from "../isLocalStorageAvailable";

export const getUsableCookies = () => {
  if (!isLocalStorageAvailable()) {
    return false;
  }
  return ({...JSON.parse(localStorage?.getItem(COOKIE_STORAGE_NAME))})
};